import ColorHash from 'color-hash'
import { COLORS, STYLES } from '@app/const/globals'
import { isValue } from './is-defined'

const colorHash = new ColorHash()

function getDefaultColors () {
  return COLORS
}

// sRGB → linear RGB
// https://www.kc-sachsen.de/fileadmin/user_upload/Testdateien_mindscreen/Web_Content_Accessibility_Guidelines__WCAG__2.1.pdf
// page 66 explains conversion
// also https://mdn2.netlify.app/en-us/docs/web/accessibility/understanding_colors_and_luminance/
const toLinear = c =>
  c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)

function contrastText (color) {
  if (!isValue(color)) return 'dark'
  if (color[0] === '#') {
    color = color.substring(1)
  }
  const r = parseInt(color.slice(0, 2), 16) / 255
  const g = parseInt(color.slice(2, 4), 16) / 255
  const b = parseInt(color.slice(4, 6), 16) / 255

  const R = toLinear(r)
  const G = toLinear(g)
  const B = toLinear(b)

  // https://en.wikipedia.org/wiki/Relative_luminance
  // https://www.kc-sachsen.de/fileadmin/user_upload/Testdateien_mindscreen/Web_Content_Accessibility_Guidelines__WCAG__2.1.pdf
  // page 66 explains luminance
  // also https://mdn2.netlify.app/en-us/docs/web/accessibility/understanding_colors_and_luminance/
  const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B

  return luminance > 0.5 ? 'dark' : 'light'
}

function idToColor (id, objects) {
  if (!id) return '666666'
  if (objects) {
    const obj = objects.find((p) => p.id === id)
    const objCol = obj && obj.color ? obj.color : null
    if (objCol) return objCol
  }
  return colorHash.hex(id.slice(-6)).slice(-6)
}

function getProgressColor (progress = 0, breakpoints = [
  { minProgress: 0, color: STYLES.colors.red },
  { minProgress: 41, color: STYLES.colors.orange },
  { minProgress: 91, color: STYLES.colors.green }
]) {
  if (typeof progress !== 'number') {
    throw new Error('Invalid type. Progress must be a number.')
  }

  return breakpoints.find((breakpoint, index) => {
    const nextBreakpoint = breakpoints[index + 1]

    if (!nextBreakpoint) {
      return breakpoint
    }

    if (progress >= breakpoint.minProgress && progress < nextBreakpoint.minProgress) {
      return breakpoint
    }
  }).color
}

export default {
  contrastText,
  idToColor,
  getDefaultColors,
  getProgressColor
}
